<template lang="pug">
  Touch(@tmove="activeScroll" @tend="scrollEnd" ref="touchWrapper")
    .scrollContent(ref="scrollContent")
      slot
</template>

<script>
  import Touch from './touch.vue';

  export default {
    name: "HorizontalScroller",

    components: {
      Touch
    },

    data() {
      return {
        translateX: 0,
        scrollOffset: 0,
        _frameId: null,
        scrolling: null,
        transitioning: null,
        swipeDirection: null,
        _scrollLock: false,
      }
    },

    props: {
      scrollLock: {
        type: Boolean,
        default: false,
      }
    },

    methods: {
      activeScroll(x, y, e) {
        if(this._scrollLock || this.transitioning || this.scrollLock) {
          return;
        }

        if(this.scrolling) {
          e.preventDefault();
          return this.scrollOffset = this.$refs.touchWrapper.x;
        }

        if(Math.abs(this.$refs.touchWrapper.y) > Math.abs(this.$refs.touchWrapper.x)) {
          this._scrollLock = true; // disable horizontal scrolling if scroll starts with vertical direction
          return;
        }

        e.preventDefault();
        this.scrolling = true;
        this.scrollOffset = this.$refs.touchWrapper.x;
        this._frameId = window.requestAnimationFrame(this.scroll);
      },

      scrollEnd() {
        if(!this._scrollLock && !this.transitioning && !this.scrollLock) {
          this.transitioning = true;
          window.cancelAnimationFrame(this._frameId);
          this.scrollEndTransition();
        } else if(this._scrollLock) {
          this._scrollLock = false;
        }
      },

      scroll() {
        const el = this.$refs.scrollContent;
        const xtrm_overscroll = el.clientWidth*0.10;  // distance someone can scroll over the edge before  being bouncing back, much extreme such edge 
        const bound_left = xtrm_overscroll;
        const bound_right = el.clientWidth - el.scrollWidth - xtrm_overscroll;  
        
        const translate_x = Math.min(Math.max(this.translateX + this.scrollOffset, bound_right), bound_left); 

        el.style.transform = `translateX(${translate_x}px)`;
        this._frameId = window.requestAnimationFrame(this.scroll);
      },

      scrollEndTransition() {
        const el = this.$refs.scrollContent;

        this.translateX = Math.min(Math.max(this.translateX + this.scrollOffset, el.clientWidth - el.scrollWidth), 0); 
        
        el.style.transition = 'transform 0.2s';
        el.style.transform = `translateX(${this.translateX}px)`;
        window.setTimeout(this.afterTransition.bind(this), 200);
      },

      afterTransition() {
        this.$refs.scrollContent.style.transition = 0;
        this.scrollOffset = 0;
        this._frameId = null;
        this.scrolling = false;
        this.transitioning = false;
      },
    },

    updated() {
      if(this.scrollLock && this.translateX !== 0) {
        this.$refs.scrollContent.style.transform = '';
        this.translateX = 0;
      }
    }
  }
</script>

<style scoped lang="stylus">
</style>

